module.exports = __webpack_public_path__ + "static/media/tick1.ee3248f7.svg";